import { TextField } from "@mui/material";
import React from "react";

interface NumberFieldProps extends React.ReactElement {
  placeholder?: string;
  required: boolean;
  fieldKey: string;
  onChange: (key: string, value: number) => void;
  value: number;
  helperText?: string;
}

const NumberField: React.FC<NumberFieldProps> = ({
  placeholder,
  required,
  fieldKey,
  onChange,
  value = "",
  helperText,
}) => {
  return (
    <TextField
      placeholder={placeholder}
      required={required}
      type="number"
      helperText={helperText}
      variant={"outlined"}
      value={value}
      onChange={(e: any) => onChange(fieldKey, Number(e.target.value))}
    />
  );
};

export default NumberField;
